
const PushNotificationScreens = {
  PUSH_NOTIFICATION: {
    PATH: '/push-notification',
    TITLE: 'Banner & Notif',
    TITLE_ALT: 'Banner & Notif',
    PERMISSION: [
      'manage_notification.read',
      'manage_popup_banner.read',
    ],
  },
  LIST_PUSH_NOTIFICATION: {
    PATH: '/push-notification/index',
    TITLE: 'List Banner & Notif',
    TITLE_ALT: 'List',
    PERMISSION: [
      'manage_notification.read',
      'manage_popup_banner.read',
    ],
  },
  ADD_PUSH_NOTIFICATION: {
    PATH: '/push-notification/add',
    TITLE: 'Add Banner & Notif',
    TITLE_ALT: 'Add Banner & Notif',
    PERMISSION: [
      'manage_notification.create',
      'manage_popup_banner.create',
    ],
  },
  ADD_PUSH_NOTIFICATION_TARGET_CONTENT: {
    PATH: '/push-notification/add/select-content',
    TITLE: 'Add Banner & Notif',
    TITLE_ALT: 'Add Banner & Notif',
    PERMISSION: [
      'manage_notification.create',
      'manage_popup_banner.create',
    ],
  },
  REUSE_PUSH_NOTIFICATION: {
    PATH: '/push-notification/reuse/:id',
    TITLE: 'Edit Banner & Notif',
    TITLE_ALT: 'Edit Banner & Notif',
    PERMISSION: 'manage_notification.create',
  },
  REUSE_PUSH_NOTIFICATION_TARGET_CONTENT: {
    PATH: '/push-notification/reuse/:id/select-content',
    TITLE: 'Edit Banner & Notif',
    TITLE_ALT: 'Edit Banner & Notif',
    PERMISSION: 'manage_notification.create',
  },
  DETAIL_PUSH_NOTIFICATION: {
    PATH: '/push-notification/detail/:id',
    TITLE: 'Banner & Notif',
    TITLE_ALT: 'Banner & Notif',
    PERMISSION: [
      'manage_notification.read',
      'manage_popup_banner.read',
    ],
  },
  EDIT_PUSH_NOTIFICATION: {
    PATH: '/push-notification/edit/:id',
    TITLE: 'Edit Banner & Notif',
    TITLE_ALT: 'Edit Banner & Notif',
    PERMISSION: [
      'manage_notification.update',
      'manage_popup_banner.update',
    ],
  },
  EDIT_PUSH_NOTIFICATION_TARGET_CONTENT: {
    PATH: '/push-notification/edit/:id/select-content',
    TITLE: 'Edit Banner & Notif',
    TITLE_ALT: 'Edit Banner & Notif',
    PERMISSION: [
      'manage_notification.update',
      'manage_popup_banner.update',
    ],
  }
};

export default PushNotificationScreens;
